import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import {WorkOrdersByRevisionCodeContainer} from '@widgets/work-orders'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const WorkOrdersByRevisionCodeYtdContainer: React.FC<Props> = ({
  plantId,
  cardBoxSx,
  placeholderWrapperSx
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)
  const endOfToday = moment.utc().tz(timezone).endOf('day')
  const startOfYear = endOfToday.clone().startOf('year')
  const currentYear = endOfToday.year()

  return (
    <WorkOrdersByRevisionCodeContainer
      plantId={plantId}
      from={startOfYear.toISOString()}
      to={endOfToday.toISOString()}
      timeRangeLabel={`${t('workOrdersByRevision.label.ytd')} ${currentYear}`}
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
    />
  )
}
